import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Building2,
    LogOut,
    ArrowLeftRight,
    ChevronsUpDown,
} from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/src/shadComponents/ui/dropdown-menu';
import OrgContext from '@/src/Authentication/components/OrgContext';
import AuthContext from '@/src/Authentication/components/AuthContext';
import OrgSwitcherDialog from './OrgSwitcherDialog';

interface UserMenuProps {
    logout: () => void;
}

export default function UserMenu({ logout }: UserMenuProps) {
    const navigate = useNavigate();
    const orgContext = useContext(OrgContext);
    const { auth } = useContext(AuthContext);
    const [orgSwitcherOpen, setOrgSwitcherOpen] = useState(false);

    const orgs = auth?.orgs || [];
    const hasMultipleOrgs = orgs.length > 1;

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-accent hover:text-accent-foreground outline-none cursor-pointer">
                    <div className="flex size-7 shrink-0 items-center justify-center rounded-md bg-muted">
                        <Building2 className="size-3.5" />
                    </div>
                    <div className="hidden sm:flex flex-col gap-0.5 leading-none text-left">
                        <span className="font-medium text-xs truncate max-w-[140px]">
                            {orgContext.org?.name}
                        </span>
                        <span className="text-[10px] text-muted-foreground truncate max-w-[140px]">
                            {auth?.username}
                        </span>
                    </div>
                    <ChevronsUpDown className="size-3.5 shrink-0 text-muted-foreground" />
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    align="end"
                    sideOffset={8}
                    className="w-56"
                >
                    <DropdownMenuItem onSelect={() => navigate('/org')}>
                        <Building2 className="mr-2 size-4" />
                        Organization Settings
                    </DropdownMenuItem>
                    {hasMultipleOrgs && (
                        <DropdownMenuItem
                            onSelect={() => setOrgSwitcherOpen(true)}
                        >
                            <ArrowLeftRight className="mr-2 size-4" />
                            Switch Organization
                        </DropdownMenuItem>
                    )}
                    <DropdownMenuItem onSelect={logout}>
                        <LogOut className="mr-2 size-4" />
                        Logout
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>

            {hasMultipleOrgs && (
                <OrgSwitcherDialog
                    open={orgSwitcherOpen}
                    onOpenChange={setOrgSwitcherOpen}
                    orgs={orgs}
                    currentOrgId={orgContext.org?.id}
                    onSelect={(org) => {
                        orgContext.setOrg(org as any);
                        navigate('/home');
                    }}
                />
            )}
        </>
    );
}
